/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsectioncontact3Inputs */

const en_placewebsectioncontact3 = /** @type {(inputs: Placewebsectioncontact3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_placewebsectioncontact3 = /** @type {(inputs: Placewebsectioncontact3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Placewebsectioncontact3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsectioncontact3 = /** @type {((inputs?: Placewebsectioncontact3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsectioncontact3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsectioncontact3(inputs)
	return de_placewebsectioncontact3(inputs)
});
export { placewebsectioncontact3 as "placeWebSectionContact" }